var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('inline-svg',{class:_vm.isSelected ?
    'MenuRow__icon--active' :
    'MenuRow__icon--unactive',attrs:{"src":require('@/assets/' + _vm.icon)}})}
var staticRenderFns = []

export { render, staticRenderFns }